import { apiClient } from './client';
import { DEFAULT_CONFIG, FinderConfig, GradeOption } from '../types/finderConfig';
import { normalizeSchoolSections } from '../lib/schoolSections';
import { normalizeMapRings } from '../lib/mapRings';

/**
 * Normalize `gradesEnabled` to `GradeOption[]`. Tolerates the legacy shape (a
 * bare array of grade-value strings) so older saved settings still render.
 */
const normalizeGrades = (raw: unknown): GradeOption[] => {
  if (!Array.isArray(raw)) return [];
  return raw.map((g) => (typeof g === 'string'
    ? { value: g, label: g }
    : {
      value: String(g.value),
      label: g.label ?? String(g.value),
    }));
};

/**
 * Boot config from enrollment-be. Wire shape is camelCase and already matches
 * FinderConfig — we only patch a couple of fields with defaults so downstream
 * consumers (initI18n, buildTheme) can rely on non-empty values.
 */
export async function fetchFinderConfig(): Promise<FinderConfig> {
  try {
    const { data } = await apiClient.get<FinderConfig>('/finder/config');
    return {
      ...data,
      primaryColor: data.primaryColor || DEFAULT_CONFIG.primaryColor,
      secondaryColor: data.secondaryColor || DEFAULT_CONFIG.secondaryColor,
      gradesEnabled: normalizeGrades(data.gradesEnabled),
      languagesEnabled: data.languagesEnabled?.length
        ? data.languagesEnabled
        : DEFAULT_CONFIG.languagesEnabled,
      schoolSections: normalizeSchoolSections(data.schoolSections),
      mapRings: normalizeMapRings(data.mapRings),
      snapToStreet: Boolean(data.snapToStreet),
      hideZonedBadge: Boolean(data.hideZonedBadge),
    };
  } catch (err) {
    console.error('[configService] fetchFinderConfig failed', err);
    throw err;
  }
}
